import {
  GiftCard_Status,
  GiftCard_Status as GiftCardStatus,
} from "gen/giftcard/models_pb"
import { UUID as PBUUID } from "gen/proto/uuid/models_pb"
import Link from "next/link"
import { ReactNode } from "react"
import { Chip, ChipColor } from "shared-web/components/base/informational/Chip"

import { classNames } from "lib/classNames"
import { urls } from "urls"

export function formatCardNumber(cardNumber: string) {
  return `•••• •••• •••• ${cardNumber}`
}

export function GiftCardNumberLink({
  cardNumberLast4,
  giftCardId,
  className,
}: {
  cardNumberLast4: string
  giftCardId: PBUUID
  className?: string
}) {
  return (
    <Link
      href={urls.giftCard(giftCardId)}
      className={classNames("underline", className)}
      onClick={(e) => e.stopPropagation()}
    >
      {formatCardNumber(cardNumberLast4)}
    </Link>
  )
}

export function formatStatus(status: GiftCardStatus | undefined): ReactNode {
  if (!status) return ""

  return (
    <Chip
      color={giftCardStatusChipColor(status)}
      text={giftCardStatusLabel(status)}
    />
  )
}

export function giftCardStatusLabel(status: GiftCard_Status): string {
  return {
    [GiftCard_Status.UNDEFINED]: "",
    [GiftCard_Status.CREATED]: "Pending Activation",
    [GiftCard_Status.ACTIVE]: "Active",
    [GiftCard_Status.DEACTIVATED]: "Deactivated",
  }[status]
}

export function giftCardStatusChipColor(status: GiftCard_Status): ChipColor {
  const colorMap: Record<GiftCard_Status, ChipColor> = {
    [GiftCard_Status.UNDEFINED]: "gray",
    [GiftCard_Status.CREATED]: "gray",
    [GiftCard_Status.ACTIVE]: "green",
    [GiftCard_Status.DEACTIVATED]: "red",
  }
  return colorMap[status]
}
